(function ($) {
    var core = {
        document: $(document),
        orderform: '.wp-block-vhc-orderform',
        orderformField: '.orderform__field input',
        emailField: 'input[name="email"]',

        variantSelectorRegular: '.orderform__variant-selector--regular',
        variantSelectorVariant: '.orderform__variant-selector--variant',
        regularContent: '.orderform__regular',
        variantContent: '.orderform__variant',

        buyBoxOpenOrderform: '.buy-box__open-orderform', 
        buyBoxHybridTier2: '.buy-box__tier-2 a',
        buyBoxHybridTier3: '.buy-box__tier-3 a',
        buyBoxHybridTier2OpenOrderform: '.buy-box__tier-2-open-orderform a',
        buyBoxHybridTier3OpenOrderform: '.buy-box__tier-3-open-orderform a',

        handleVariantSwitch: function() {
            $(core.variantSelectorRegular).addClass('orderform__variant-selector--active');
            $(core.variantContent).hide();
            $('.orderform__variant .orderform__legal-text').hide();
            
            $('.orderform__variant input.orderform__legal-text-checkbox, .orderform__regular input.orderform__legal-text-checkbox').remove();
            
            $(core.variantSelectorRegular).on('click', function() {
                $(core.regularContent).show();
                $('.orderform__regular .orderform__legal-text').show();
                $(core.variantContent).hide();
                $('.orderform__variant .orderform__legal-text').hide();
                $(core.variantSelectorRegular).addClass('orderform__variant-selector--active');
                $(core.variantSelectorVariant).removeClass('orderform__variant-selector--active');
            });

            $(core.variantSelectorVariant).on('click', function() {
                $(core.variantContent).show();
                $('.orderform__variant .orderform__legal-text').show();
                $(core.regularContent).hide();
                $('.orderform__regular .orderform__legal-text').hide();
                $(core.variantSelectorVariant).addClass('orderform__variant-selector--active');
                $(core.variantSelectorRegular).removeClass('orderform__variant-selector--active');
            });
        },

        submitOrder: function (e) {
            e.preventDefault();
            e.stopPropagation();

            var data = $(this).serializeArray();
            var dataObj = {};
            data.forEach(function (item) {
                dataObj[item.name] = item.value;
            });

            $.ajax({
                method: "POST",
                url: theme.ajax_url,
                data: {
                    action: "vhc_submit_order",
                    datastring: $.param(dataObj)
                },
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).done(function (response) {
                try {
                    var jsonResponse = JSON.parse(response);
                    console.log(jsonResponse);

                    if (jsonResponse.message == 'order_processed' || jsonResponse.message == 'order_queued') {
                        if (jsonResponse.message == 'order_queued') {
                            document.cookie = "order_queue_cookie=" + jsonResponse.order_id + "; path=/";
                        }

                        dataLayer.push({
                            'event': 'order_processed'
                        });

                        var orionFbPixelId = dataObj.orion_fb_pixel_id;
                        var convergeClientSideId = dataObj.converge_client_side_id;
                        var commercetoolsProductId = dataObj.commercetools_product_id;
                        var purchaseId = dataObj.purchase_id;
                        var sku = dataObj.sku;
                        var value = dataObj.value;
                        var currency = dataObj.currency;
                        var email = dataObj.email;
                        var telephone = dataObj.telephone;
                        var cleanPhone = telephone.replace(/[^\d+]+/g, '');
                        var city = dataObj.city;
                        var zipcode = dataObj.zipcode;
                        var vat = dataObj.vat;
                        var user_id = dataObj.user_id;
                        var productName = dataObj.product_name;
                        var convergeProductId = dataObj.converge_product_id;
                        var convergeVariantId = dataObj.converge_variant_id;
                        var convergeVariantName = dataObj.converge_variant_name;

                        const CURRENCY_TO_COUNTRY = {
                            'NOK': 'NO',
                            'SEK': 'SE',
                            'EUR': 'FI'
                        };

                        const country = CURRENCY_TO_COUNTRY[currency] || 'NO';

                        if ( orionFbPixelId ) {
                            $('body').append('<iframe src="https://' + orionFbPixelId + '/thanks.php" width="1px" height="1px"></iframe>');
                            console.log('orionFbPixelId fired, is : ' + orionFbPixelId);
                        }

                        if ( convergeClientSideId ) {
                            try {
                                cvg({
                                    method: "forward",
                                    eventName: "Placed Order",
                                    eventID: purchaseId,
                                    properties: {
                                        id: purchaseId,
                                        total_price: +value.toString().replace(',', '.'),
                                        total_tax: vat,
                                        total_shipping: 0,
                                        currency: currency.toUpperCase(),
                                        items: [{
                                            product_id: convergeProductId,
                                            variant_id: convergeVariantId,
                                            sku: sku,
                                            name: productName,
                                            variant_name: convergeVariantName,
                                            price: +value.toString().replace(',', '.'),
                                            currency: currency,
                                            quantity: 1,
                                            vendor: "VHC Nordics",
                                        }],
                                        $is_new_customer: true
                                    },
                                    profileProperties: {
                                        $email: email,
                                        $phone_number: cleanPhone,
                                        $city: city,
                                        $country_code: country,
                                        $state: "",
                                        $zip_code: zipcode,
                                    },
                                    aliases: [
                                        'urn:email:' + email,
                                        'urn:user_id:' + user_id,
                                    ]
                                });
                            } catch(e) {
                                console.error('Error firing Converge tracking:', e);
                            }

                            try {
                                cvg({
                                    method: "track",
                                    eventName: "Placed Order (Subscription Page Only)",
                                    eventID: purchaseId,
                                    properties: {
                                        id: purchaseId,
                                        total_price: +value.toString().replace(',', '.'),
                                        total_tax: vat,
                                        total_shipping: 0,
                                        currency: currency.toUpperCase(),
                                        items: [{
                                            product_id: convergeProductId,
                                            variant_id: convergeVariantId,
                                            sku: sku,
                                            name: productName,
                                            variant_name: convergeVariantName,
                                            price: +value.toString().replace(',', '.'),
                                            currency: currency,
                                            quantity: 1,
                                            vendor: "VHC Nordics",
                                        }],
                                        $is_new_customer: true
                                    },
                                    profileProperties: {
                                        $email: email,
                                        $phone_number: cleanPhone,
                                        $city: city,
                                        $country_code: country,
                                        $state: "",
                                        $zip_code: zipcode,
                                    },
                                    aliases: [
                                        'urn:email:' + email,
                                        'urn:user_id:' + user_id,
                                    ]
                                });
                            } catch(e) {
                                console.error('Error firing Converge tracking:', e);
                            }
                        } else {
                            console.warn('Converge tracking not fired:', {
                                hasConvergeId: !!convergeClientSideId,
                                cvgFunctionExists: typeof cvg === 'function'
                            });
                        }
                    }

                    if (jsonResponse.message == 'upsell_processed') {
                        dataLayer.push({
                            'event': 'upsell_processed'
                        });
                    }

                    document.cookie = "orderform_cookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
                    document.cookie = "orderform_cookie=" + $.param(dataObj) + "; path=/";
                    e.currentTarget.submit();
                    
                } catch (e) {
                    if (dataObj.payment_method === 'adyen') {
                        document.open();
                        document.write(response);
                        document.close();
                    } else {
                        console.error("Unexpected response:", response);
                    }
                }
            });
        },

        trackAddToCart: function () {
            var firstName = $(this).closest('form').find('input[name="first_name"]').val();
            var lastName = $(this).closest('form').find('input[name="last_name"]').val();
            var address = $(this).closest('form').find('input[name="address"]').val();
            var city = $(this).closest('form').find('input[name="city"]').val();
            var zipcode = $(this).closest('form').find('input[name="zipcode"]').val();
            var email = $(this).closest('form').find('input[name="email"]').val();
            var sku = $(this).closest('form').find('input[name="sku"]').val();
            var addToCartId = $(this).closest('form').find('input[name="add_to_cart_id"]').val();
            var value = $(this).closest('form').find('input[name="value"]').val();
            var currency = $(this).closest('form').find('input[name="currency"]').val();
            var convergeClientSideId = $(this).closest('form').find('input[name="converge_client_side_id"]').val();
            var user_id = $(this).closest('form').find('input[name="user_id"]').val();
            var productName = $(this).closest('form').find('input[name="product_name"]').val();
            var convergeProductId = $(this).closest('form').find('input[name="converge_product_id"]').val();
            var convergeVariantId = $(this).closest('form').find('input[name="converge_variant_id"]').val();
            var convergeVariantName = $(this).closest('form').find('input[name="converge_variant_name"]').val();

            if (firstName !== '' || sku !== '' || addToCartId !== '' || value !== '' || currency !== '' ) {            
                dataLayer.push({
                    'event': 'add_to_cart',
                    'first_name': firstName
                });
                
                $.ajax({
                    method: "POST",
                    url: theme.ajax_url, 
                    data: {
                        action: "vhc_add_to_cart",
                        datastring: $.param({
                            add_to_cart_id: addToCartId,
                            first_name: firstName,
                            sku: sku,
                            value: value,
                            currency: currency, 
                            product_name: productName,
                            converge_product_id: convergeProductId,
                            converge_variant_id: convergeVariantId,
                            converge_variant_name: convergeVariantName,
                        })
                    },
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }).done(function (response) {
                    if ( convergeClientSideId ) {
                        try {
                            cvg({
                                method: "track",
                                eventName: "Added To Cart",
                                properties: {
                                    product_id: convergeProductId,
                                    variant_id: convergeVariantId,
                                    sku: sku,
                                    name: productName,
                                    variant_name: convergeVariantName,
                                    price: value,
                                    currency: currency.toUpperCase(),
                                    quantity: 1,
                                    vendor: "VHC Nordics"
                                }, 
                                aliases: [
                                    'urn:email:' + email,
                                    'urn:user_id:' + user_id,
                                ]
                            });
                        } catch(e) {
                            console.error('Error firing Converge Add to Cart tracking:', e);
                        }
                    } else {
                        console.warn('Converge Add to Cart tracking not fired:', {
                            hasConvergeId: !!convergeClientSideId,
                            cvgFunctionExists: typeof cvg === 'function'
                        });
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    console.error("Add to cart request failed:", textStatus, errorThrown);
                });
            }
        },

        openBuyBoxOrderform: function () {
            const buyBoxOrderform = '.buy-box__orderform';
            const tier2Orderform = '.buy-box__tier-2-orderform';
            const tier3Orderform = '.buy-box__tier-3-orderform';
            $(buyBoxOrderform).show();
            $(tier2Orderform).hide();
            $(tier3Orderform).hide();
            
            // Smooth scroll to the buy box orderform, offset by 110px
            $('html, body').animate({
                scrollTop: $(buyBoxOrderform).offset().top - 110
            }, 800); // 800ms duration for smooth animation
        },

        addCookieValuesToHrefs: function() {
            function getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(';').shift();
                return '';
            }

            const cvgUid = getCookie('__cvg_uid');
            const cvgSid = getCookie('__cvg_sid');

            $('a[href^="https://vitaminexpress.se/cart/load"], a[href^="https://vitaminexpress.no/cart/load"], a[href^="https://vitaminexpress.fi/cart/load"], a[href^="https://vitaminexpress.de/cart/load"]').each(function () {
                let href = $(this).attr('href');
                if (href) {
                    // Create URL object to handle parameters properly
                    const url = new URL(href);
                    
                    // Remove any existing parameters before adding them again
                    url.searchParams.delete('__cvg_uid');
                    url.searchParams.delete('__cvg_sid');
                    
                    // Add parameters if cookies exist
                    if (cvgUid) {
                        url.searchParams.append('__cvg_uid', cvgUid);
                    }
                    if (cvgSid) {
                        url.searchParams.append('__cvg_sid', cvgSid);
                    }
                    
                    // Update href with new URL
                    $(this).attr('href', url.toString());
                }
            });
        },

        trackHybridTier2: function (e) {
            e.preventDefault(); // Prevent immediate navigation
            
            var $link = $(this);
            var href = $link.attr('href');
            var sku = $link.closest('form').find('input[name="sku"]').val();
            var value = $link.closest('form').find('input[name="value"]').val();
            var currency = $link.closest('form').find('input[name="currency"]').val();
            var convergeProductId = $link.closest('form').find('input[name="converge_product_id"]').val();
            var convergeVariantId = $link.closest('form').find('input[name="converge_variant_id"]').val();
            var convergeVariantName = $link.closest('form').find('input[name="converge_variant_name"]').val();
            var productName = $link.closest('form').find('input[name="product_name"]').val();

            try {
                console.log('trackHybridTier2 - start tracking');
                
                // Add a safety timeout in case the callback never fires
                var redirectTimeout = setTimeout(function() {
                    console.log('trackHybridTier2 - timeout redirect');
                    window.location.href = href;
                }, 1000); // 1 second timeout
                
                cvg({
                    method: "track",
                    eventName: "Proceeded To Checkout",
                    properties: {
                        product_id: convergeProductId,
                        variant_id: convergeVariantId,
                        sku: sku,
                        name: productName,
                        variant_name: convergeVariantName,
                        price: value,
                        currency: currency,
                        vendor: "VHC Nordics",
                    },
                    callback: function() {
                        clearTimeout(redirectTimeout);
                        console.log('trackHybridTier2 - tracking complete, redirecting');
                        window.location.href = href;
                    }
                });
            } catch(e) {
                console.error('Error in trackHybridTier2:', e);
                window.location.href = href; // Navigate even if tracking fails
            }
        },

        trackHybridTier3: function (e) {
            e.preventDefault(); // Prevent immediate navigation
            
            var $link = $(this);
            var href = $link.attr('href');
            var sku = $link.closest('form').find('input[name="sku"]').val();
            var value = $link.closest('form').find('input[name="value"]').val();
            var currency = $link.closest('form').find('input[name="currency"]').val();
            var convergeProductId = $link.closest('form').find('input[name="converge_product_id"]').val();
            var convergeVariantId = $link.closest('form').find('input[name="converge_variant_id"]').val();
            var convergeVariantName = $link.closest('form').find('input[name="converge_variant_name"]').val();
            var productName = $link.closest('form').find('input[name="product_name"]').val();
            
            try {
                console.log('trackHybridTier3 - start tracking');
                
                // Add a safety timeout in case the callback never fires
                var redirectTimeout = setTimeout(function() {
                    console.log('trackHybridTier3 - timeout redirect');
                    window.location.href = href;
                }, 1000); // 1 second timeout
                
                cvg({
                    method: "track",
                    eventName: "Proceeded To Checkout",
                    properties: {
                        product_id: convergeProductId,
                        variant_id: convergeVariantId,
                        sku: sku,   
                        name: productName,
                        variant_name: convergeVariantName,
                        price: value,
                        currency: currency,
                        vendor: "VHC Nordics",
                    },
                    callback: function() {
                        clearTimeout(redirectTimeout);
                        console.log('trackHybridTier3 - tracking complete, redirecting');
                        window.location.href = href;
                    }
                });
            } catch(e) {
                console.error('Error in trackHybridTier3:', e);
                window.location.href = href; // Navigate even if tracking fails
            }
        },

        openTier2Orderform: function () {
            const buyBoxOrderform = '.buy-box__orderform';
            const tier2Orderform = '.buy-box__tier-2-orderform';
            const tier3Orderform = '.buy-box__tier-3-orderform';
            $(buyBoxOrderform).hide();
            $(tier2Orderform).show();
            $(tier3Orderform).hide();
            
            // Smooth scroll to the buy box orderform, offset by 110px
            $('html, body').animate({
                scrollTop: $(tier2Orderform).offset().top - 110
            }, 800); // 800ms duration for smooth animation
        },

        openTier3Orderform: function () {
            const buyBoxOrderform = '.buy-box__orderform';
            const tier2Orderform = '.buy-box__tier-2-orderform';
            const tier3Orderform = '.buy-box__tier-3-orderform';
            $(buyBoxOrderform).hide();
            $(tier2Orderform).hide();
            $(tier3Orderform).show();
            
            // Smooth scroll to the buy box orderform, offset by 110px
            $('html, body').animate({
                scrollTop: $(tier3Orderform).offset().top - 110
            }, 800); // 800ms duration for smooth animation
        },

        init: function () {
            core.document.one('submit', core.orderform, core.submitOrder);
            core.document.on('change', core.emailField, core.trackAddToCart);
            core.document.on('click', core.buyBoxOpenOrderform, core.openBuyBoxOrderform);
            core.document.on('click', core.buyBoxHybridTier2, core.trackHybridTier2);
            core.document.on('click', core.buyBoxHybridTier3, core.trackHybridTier3);
            core.document.on('click', core.buyBoxHybridTier2OpenOrderform, core.openTier2Orderform);
            core.document.on('click', core.buyBoxHybridTier3OpenOrderform, core.openTier3Orderform);
            core.handleVariantSwitch();
            
            // Add document ready handler for cookie values
            $(document).ready(core.addCookieValuesToHrefs);
        },
    };
    core.init();
})(jQuery);
